import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { catchError, throwError } from 'rxjs';
import { valueOrUndefined } from '@web/utils';

export const HttpBlobResponseErrorInterceptor: HttpInterceptorFn = (
  request,
  next,
) => {
  return next(request).pipe(
    catchError((err) => {
      if (
        err instanceof HttpErrorResponse &&
        err.error instanceof Blob &&
        err.error.type === 'application/json'
      ) {
        // https://github.com/angular/angular/issues/19888
        // When request of type Blob, the error is also in Blob instead of object of the json data
        return new Promise<any>((resolve, reject) => {
          const reader = new FileReader();
          reader.onload = (e: Event) => {
            try {
              const errmsg = JSON.parse((<any>e.target).result);
              reject(
                new HttpErrorResponse({
                  error: errmsg,
                  headers: err.headers,
                  status: err.status,
                  statusText: err.statusText,
                  url: valueOrUndefined(err.url),
                }),
              );
            } catch (e) {
              reject(err);
            }
          };
          reader.onerror = (e) => {
            reject(err);
          };
          reader.readAsText(err.error);
        });
      }
      return throwError(() => err);
    }),
  );
};
